declare var localizer: any;
let webUser: CustomerAPI.WebUser;
let startedLogin = false;
let hasLoggedIn = false;
let loginCallbacks: () => void = null;


$(document).ready(function () {
    $('#toForgot').click(function (e) {
        e.preventDefault();
        $('div#form-login').toggle('500');
        $('div#form-forgot-password').toggle('500');
    });
    $('#toLogin').click(function (e) {
        e.preventDefault();
        $('div#form-login').toggle('500');
        $('div#form-forgot-password').toggle('500');
    });

    $('#loginModal').on('show.bs.modal', function (event) {
        $('div#form-login').show();
        $('div#form-forgot-password').hide();
    });

    if (getQueryStringValue("login") == "true")
        ($("#loginModal") as any).modal("show");
});

function LoginButton(form)
{
    var btn = $(form).find("input");
    btn.prop("disabled", true);
    $('#loginError').html('');
    CustomerAPI.login($('#loginUsername').val(), $('#loginPassword').val(),
        function () {
            var imei = getQueryStringValue("imei");
            if (imei) {
                window.location.href = '/My/Devices?imei='+ imei;
            } else {
                window.location.href = '/My/Devices';
            }
        },
        function (ex, reason) {
            btn.prop("disabled", false);
            $('#loginError').html(reason);
        });
    return false;
}

function LoggedIn()
{
	CustomerAPI.RefreshToken(() => console.debug("Refresh success"), (ex, reason) => console.debug("Refresh failed. " + ex));
	let loginOut = $("#loginOut");
    loginOut.text(localizer["IndexButtonLogout"]);
    loginOut.click(event => { localStorage.setItem("loginToken", null); localStorage.setItem("loginTokenExpiration", null); window.location.href = "/"; } );
	$(".display-when-logged-in").toggle(true);
	$(".hide-when-logged-in").toggle(false);
}

function LoggedOut()
{
    let loginOut = $("#loginOut");
    loginOut.text(localizer["LogInHeader"]);
	loginOut.attr("data-target", "#loginModal");
	let myMenues = $(".my-menues");
	myMenues.toggle(false);

	$(".display-when-logged-out").toggle(true);
	$(".hide-when-logged-out").toggle(false);
}

function SendResetPasswordMail()
{
    var user = $("#forgotEmail").val() as string;
    if (user == null || user == "")
    {
        $('#forgotError').html(localizer["ForgotPasswordMissingEmail"]);
        return;
    }

    CustomerAPI.customerAPI.forgotPassword(user, () => Alert.OpenError(localizer["ForgotPasswordSuccessTitle"], localizer["ForgotPasswordSuccessDesc"]), (ex, reason) => Alert.OpenError(localizer["ForgotPasswordError"], ex));
}

function RequireLogin(isLoggedIn?: () => void)
{
    if (hasLoggedIn)
    {
        if (isLoggedIn != undefined)
            isLoggedIn();
        return;
    }
    if (startedLogin)
    {
        if (isLoggedIn != undefined)
        {
            let prevCallback = loginCallbacks;
            loginCallbacks = () =>
            {
                prevCallback();
                try { isLoggedIn(); }
                catch (e) {
                    console.error(e);
                }
            };
        }
        return;
    }
    
    startedLogin = true;
    loginCallbacks = isLoggedIn;
    $(document).ready(() =>
    {
        CustomerAPI.customerAPI.getUser(usr =>
        {
            webUser = usr;
            hasLoggedIn = true;
            if (loginCallbacks != null)
                try { loginCallbacks(); }
                catch (e) { console.error(e); } 
        }, (ex, reason) =>
        {
            window.location.href = "/?login=true";
        });
     });
}

function RequireLoginGetTriggers(imei: string, isLoggedIn?: (triggers: CustomerAPI.Trigger[]) => void) {
    $(document).ready(() => {
        CustomerAPI.notificationService.get(imei, response => {
            if (isLoggedIn != undefined)
                try { isLoggedIn(response.triggers); }
                catch (e) { console.error(e); }
        }, (ex, reason) => {
            window.location.href = "/?login=true";
        });
    });
}

function getQueryStringValue(key)
{ 
  return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
} 

function DateToFullString(date: Date) : string
{
    return DateToTimeString(date) + " " + DateToDateYearString(date);
}
function DateToDateYearString(date: Date): string {
    return DateToDateString(date) + "-" + date.getFullYear();
}
function DateToDateTimeString(date: Date): string {
    return DateToDateString(date) + " " + DateToTimeString(date);
}
function DateToDateString(date: Date): string
{
    return ("0" + date.getDate()).slice(-2) + "-" + ("0" + (date.getMonth() + 1)).slice(-2);
}

function DateToTimeString(date: Date): string
{
    return ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2);
}

function formatDate(date: Date) {
    var monthNames = [
        localizer["Jan"],
        localizer["Feb"],
        localizer["Mar"],
        localizer["Apr"],
        localizer["May"],
        localizer["Jun"],
        localizer["Jul"],
        localizer["Aug"],
        localizer["Sep"],
        localizer["Oct"],
        localizer["Nov"],
        localizer["Dec"],
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var hour = date.getHours();
    var minutes = date.getMinutes();

    return day + ' ' + monthNames[monthIndex] + ' ' + hour + ':' + minutes;
}